import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../Confirmation'

import { QA_NAME_EMAIL_TEST_VARIABLES_CONFIRMATION_MODAL } from './EmailConfirmationTestVariablesModal.constants'

function EmailConfirmationTestVariablesModal({ onClose }) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      actionButtonsProps={{
        Cancel: null,
        submitText: t('Email.TestVariablesOkTitleKey'),
      }}
      description={t('Email.TestVariablesOkTextKey')}
      qaName={QA_NAME_EMAIL_TEST_VARIABLES_CONFIRMATION_MODAL}
      title={t('Modal.TestVariablesConfirmationModalTitle')}
      onClose={onClose}
      onSubmit={onClose}
    />
  )
}

export default EmailConfirmationTestVariablesModal
